/** Who the shop buys from, and what it owes them. */
const suppliers = {
  en: {
    title: "Suppliers",
    subtitle: "Who you buy from, and what you still owe each of them.",
    loadFailed: "Could not load your suppliers.",
    saveFailed: "Could not save that.",
    totalOwed: "You owe",
    add: "Add a supplier",
    added: "{name} added.",
    name: "Name",
    phone: "Phone",
    notes: "Note",
    save: "Save supplier",
    none: "No suppliers yet — they are added the first time you record a delivery from them.",
    lastDelivery: "last delivery {day}",
    noDelivery: "no delivery yet",
    awaitingPrices: { one: "{count} delivery awaiting prices", other: "{count} deliveries awaiting prices" },
    owed: "owed {amount}",
    ahead: "{amount} paid ahead",
    settled: "settled",
    history: "History",
    pay: "Pay",
    payTitle: "Paying {name}",
    currentlyOwed: "Currently owed: {amount}",
    amount: "Amount ({currency})",
    recordPayment: "Record payment",
    paid: "Paid {name} {amount}.",
    nothingYet: "Nothing between you yet.",
    deliveryOf: "Delivery — {amount}",
    payment: "Paid {amount}",
    paymentFromDrawer: "Paid {amount} from the till's drawer",
    paymentFromSafe: "Paid {amount} from your savings",
    owedAfter: "owed {amount} after",
  },
  fr: {
    title: "Fournisseurs",
    subtitle: "Chez qui vous achetez, et ce que vous devez encore à chacun.",
    loadFailed: "Impossible de charger vos fournisseurs.",
    saveFailed: "Impossible d'enregistrer.",
    totalOwed: "Vous devez",
    add: "Ajouter un fournisseur",
    added: "{name} ajouté.",
    name: "Nom",
    phone: "Téléphone",
    notes: "Note",
    save: "Enregistrer le fournisseur",
    none: "Aucun fournisseur — ils sont ajoutés à la première livraison enregistrée.",
    lastDelivery: "dernière livraison {day}",
    noDelivery: "pas encore de livraison",
    awaitingPrices: { one: "{count} livraison à compléter", other: "{count} livraisons à compléter" },
    owed: "dû {amount}",
    ahead: "{amount} payé d'avance",
    settled: "à jour",
    history: "Historique",
    pay: "Payer",
    payTitle: "Paiement à {name}",
    currentlyOwed: "Actuellement dû : {amount}",
    amount: "Montant ({currency})",
    recordPayment: "Enregistrer le paiement",
    paid: "{name} payé {amount}.",
    nothingYet: "Rien entre vous pour l'instant.",
    deliveryOf: "Livraison — {amount}",
    payment: "Payé {amount}",
    paymentFromDrawer: "Payé {amount} depuis le tiroir de la caisse",
    paymentFromSafe: "Payé {amount} depuis votre épargne",
    owedAfter: "dû ensuite {amount}",
  },
  ar: {
    title: "الموردون",
    subtitle: "ممن تشتري، وما تبقى عليك لكل منهم.",
    loadFailed: "تعذّر تحميل الموردين.",
    saveFailed: "تعذّر الحفظ.",
    totalOwed: "عليك",
    add: "إضافة مورد",
    added: "تمت إضافة {name}.",
    name: "الاسم",
    phone: "الهاتف",
    notes: "ملاحظة",
    save: "حفظ المورد",
    none: "لا يوجد موردون بعد — يُضافون عند تسجيل أول توريد منهم.",
    lastDelivery: "آخر توريد {day}",
    noDelivery: "لا توريد بعد",
    awaitingPrices: { zero: "لا توريدات بانتظار الأسعار", one: "توريد واحد بانتظار الأسعار", two: "توريدان بانتظار الأسعار", few: "{count} توريدات بانتظار الأسعار", many: "{count} توريداً بانتظار الأسعار", other: "{count} توريد بانتظار الأسعار" },
    owed: "عليك {amount}",
    ahead: "{amount} مدفوع مسبقاً",
    settled: "مسدَّد",
    history: "السجل",
    pay: "دفع",
    payTitle: "الدفع لـ {name}",
    currentlyOwed: "المستحق حالياً: {amount}",
    amount: "المبلغ ({currency})",
    recordPayment: "تسجيل الدفعة",
    paid: "تم دفع {amount} لـ {name}.",
    nothingYet: "لا شيء بينكما بعد.",
    deliveryOf: "توريد — {amount}",
    payment: "دفع {amount}",
    paymentFromDrawer: "دفع {amount} من درج الصندوق",
    paymentFromSafe: "دفع {amount} من مدخراتك",
    owedAfter: "المتبقي بعدها {amount}",
  },
};

export default suppliers;
